import * as t from 'io-ts'

export const nullable = <C extends t.Mixed>(codec: C) => {
  return t.union([codec, t.null])
}
